import { render, staticRenderFns } from "./MerciView.vue?vue&type=template&id=525dfdda"
var script = {}
import style0 from "./MerciView.vue?vue&type=style&index=0&id=525dfdda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports